const tool = {
    /**
     * 格式化手机号，中间四位替换为****
     * @param {string|number} phone - 手机号（支持字符串/数字类型）
     * @returns {string} 格式化后的手机号（格式错误返回原内容）
     */
    formatPhone(phone) {
        // 先转为字符串，处理数字类型入参
        const phoneStr = String(phone).trim();
        // 正则匹配11位数字的手机号
        const reg = /^(\d{3})\d{4}(\d{4})$/;
        // 匹配成功则替换，失败返回原内容
        return phoneStr.replace(reg, '$1****$2');
    },
    /**
     * 校验值的类型：纯汉字/纯数字/混合类型
     * @param {any} value - 待校验的值（支持字符串/数字）
     * @returns {string} - 'chinese'（纯汉字）| 'number'（纯数字）| 'mix'（混合）| 'other'（其他）
     */
    checkValueType(value) {
        // 1. 空值/非字符串数字处理：转为字符串并去空
        const str = String(value).trim();
        if (!str) return 'other'; // 空值归为“其他”
        // 2. 正则匹配
        const isChinese = /^[\u4e00-\u9fa5]+$/.test(str); // 纯汉字
        const isNumber = /^\d+$/.test(str); // 纯数字
        // 3. 返回类型
        if (isChinese) return 'chinese';
        if (isNumber) return 'number';
        // 4. 混合类型（含汉字+数字/汉字+字母/数字+字母等）
        if (/[\u4e00-\u9fa5]/.test(str) && /\d/.test(str)) return 'mix';
        // 5. 其他（如纯字母、符号等）
        return 'other';
    },
    // 判断文件是否是支持打开的类型
    isSupportFileType(fileName,type= ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf']) {
        if (!fileName) return false;
        // 支持的类型
        const allowTypes =type;
        // 获取后缀
        const ext = fileName
        .split('.')
        .pop()
        .toLowerCase()
        .trim();
        return allowTypes.includes(ext);
    }
}
export default {
    ...tool
};